import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'rk-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Page404Component {
  constructor(private readonly _router: Router) {}

  back() {
    this._router.navigateByUrl(this._router.url.split('/').slice(0, 3).join('/'));
  }
}
